import { useState } from 'react';
import LangSwitch from './LangSwitch';
import Logo from './Logo';

import { useTranslation } from 'react-i18next';

function HrewList({location}){
  const { t } = useTranslation();

  var selected = "text-white bg-orange-700";
  var not_selected = "text-slate-80 hover:bg-orange-600 hover:text-white";

  var t1 = not_selected, t2 = not_selected, t3 = not_selected, t4 = not_selected;

  switch(location){
    case "main_page": t1 = selected; break;
    case "products": t2 = selected; break;
    case "contact_us": t3 = selected; break;
    case "carier": t4 = selected; break;
  }

  //todo resolve actualy selected

  return ([
      <a href="/#/"         class={"select-none block rounded-md px-2 py-1 text-lg font-medium " + t1 }>{t("main_page")}</a>,
      <a href="/#/products" class={"select-none block rounded-md px-2 py-1 text-lg font-medium " + t2}>{t("products")}</a>,
      <a href="/#/contacts" class={"select-none block rounded-md px-2 py-1 text-lg font-medium " + t3}>{t("contact_us")}</a>,
      <a href="/#/carier"   class={"select-none block rounded-md px-2 py-1 text-lg font-medium " + t4}>{t("carier")}</a>
    ])
}


export default function NavBar({location = "main_page"}){
  const { t } = useTranslation();
  const [wopen, setWopen] = useState(false);

  function click(){
    setWopen(!wopen);
  }

  return (
  <nav class="bg-orange-50 bg-opacity-90 drop-shadow-xl fixed w-full top-0">
    <div class="mx-auto max-w-7xl px-2 md:px-6 lg:px-8">
      <div class="relative flex h-16 items-center justify-between">

        <div class="absolute inset-y-0 left-0 flex items-center md:hidden">
          <button type="button" onClick={click}class="relative inline-flex items-center justify-center rounded-md p-1.5 hover:bg-orange-700 bg-opacity-20 hover:text-white focus:outline-hidden" aria-controls="mobile-menu" aria-expanded="false">
            <span class="absolute -inset-0.5"></span>
            <span class="sr-only">Open main menu</span>

            <svg class="block size-6" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke="oklch(64.6% 0.222 41.116)" aria-hidden="true" data-slot="icon">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
            </svg>

          </button>
        </div>


        <a href="https://sefos.cz/" class="flex flex-1 items-center justify-center md:items-stretch md:justify-start">
          <div class="flex shrink-0 items-center">
            <Logo/>
            <h1 class="text-lg font-bold text-gray-900 pt-3 pl-4">{t("main_company_cont_text")}</h1>
          </div>
        </a>

        <div class="absolute inset-y-0 right-0 flex items-center pr-2 md:static md:inset-auto md:ml-6 md:pr-0 hidden md:block">
          <div class="flex space-x-4">
            <HrewList location={location}/>
          </div>
        </div>

        <LangSwitch/>
        
      </div>
    </div>
    {(wopen && 
    <div class="md:hidden" style={{zIndex: "150"}} id="mobile-menu">
      <div class="space-y-1 px-2 pt-2 pb-3">
        <HrewList/>
      </div>
    </div>)}
  </nav>);

};